import React from 'react';

import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import useScrollAnimation from '../hooks/useScrollAnimation';

const CTASection = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const observe = useScrollAnimation();


  return (
    <section className="relative w-full">

      <div className="bg-surface-section h-60 sm:h-52"></div>

      <div className="bg-dark-bg h-60 sm:h-52"></div>

      {/* CTA Card */}
      <div className="absolute inset-0 flex items-center justify-center z-10 px-4">
        <div className="w-full flex justify-center">

          <div
            ref={observe}
            className="animate-scale-in w-full bg-primary-dark shadow-cta"
            style={{
              maxWidth: '1200px',
              width: '100%',
              borderRadius: '32px',
              padding: 'clamp(28px, 5vw, 48px)',
              overflow: 'hidden'
            }}
          >
            <div className="flex flex-col items-center text-center gap-4 md:gap-6 w-full">

              <span
                ref={observe}
                className="animate-fade-up inline-flex items-center justify-center px-6 py-2 rounded-full bg-badge text-primary-dark text-sm sm:text-base font-bold font-almarai mb-4"
              >
                {t.ctaBadge}
              </span>

              <h2
                ref={observe}
                className="animate-fade-up w-full text-white"
                style={{
                  fontFamily: 'IBM Plex Sans Arabic, sans-serif',
                  fontWeight: 700,
                  fontSize: 'clamp(22px, 4vw, 36px)',
                  lineHeight: '1.35',
                  maxWidth: '850px',
                  margin: '0 auto',
                  wordBreak: 'break-word',
                  transitionDelay: '0.1s'
                }}
              >
                {t.ctaTitle}
              </h2>

              <p
                ref={observe}
                className="animate-fade-up w-full text-body-on-dark"
                style={{
                  fontFamily: 'Almarai, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 2.5vw, 16px)',
                  lineHeight: '1.6',
                  maxWidth: '650px',
                  margin: '0 auto',
                  wordBreak: 'break-word',
                  transitionDelay: '0.2s'
                }}
              >
                {t.ctaDescription}
              </p>

              <div
                ref={observe}
                className="animate-fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mt-4 w-full"
                style={{ transitionDelay: '0.3s' }}
              >
                <a
                  href="https://platform.connecto-me.com/signup"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 transition-all duration-300 rounded-[12px] bg-white text-primary-dark w-full sm:w-[200px] h-[52px] font-medium hover:scale-105"
                >
                  <span>{t.freeTrial}</span>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={language === 'ar' ? 'rotate-180' : ''}
                  >
                    <path
                      d="M4.16669 10H15.8334M15.8334 10L11.6667 5.83331M15.8334 10L11.6667 14.1667"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                <a
                  href="https://platform.connecto-me.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 transition-all duration-300 rounded-[12px] border border-white text-white w-full sm:w-[200px] h-[52px] font-medium hover:bg-white hover:text-primary-dark"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                    <polyline points="10 17 15 12 10 7"/>
                    <line x1="15" y1="12" x2="3" y2="12"/>
                  </svg>
                  <span>{t.login}</span>
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CTASection;
